/*
 * KnowUs.jsx
 * Created by Destin Frasier on 05/02/18
 */

import React from 'react';

export default class KnowUs extends React.Component {
    render() {
        return (
            <ul className="nav-footer-list">
                <li>
                    <a href="/about-us">About Us</a>
                </li>
                <li>
                    <a href="/rules-reservation-policies">Rules & Reservation Policies</a>
                </li>
                <li>
                    <a href="/accessibility">Accessibility Statement</a>
                </li>
            </ul>
        );
    }
}
